import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Modal.css';

class Modal extends Component {
  static propTypes = {
    id: PropTypes.string,
    close: PropTypes.bool,
    onClickNo: PropTypes.func,
    onClickYes: PropTypes.func,
    onClick: PropTypes.func,
    children: PropTypes.node,
    buttonText: PropTypes.node,
    col: PropTypes.bool,
  }

  static defaultProps = {
    id: null,
    onClickNo: null,
    onClickYes: null,
    onClick: null,
    close: false,
    children: null,
    buttonText: null,
    col: false,
  }

  classNames(...classNames) {
    const { col } = this.props;
    const names = [].concat(classNames);
    if (col) {
      names.push('col');
    }
    return names.join(' ');
  }

handleYes = (event) => {
  event.preventDefault();
  if (this.props.onClickYes) {
    this.props.onClickYes(event);
  }
}

handleNo = (event) => {
  event.preventDefault();
  if (this.props.onClickNo) {
    this.props.onClickNo(event);
  }
}

handleOnClick = (event) => {
  event.preventDefault();
  if (this.props.onClick) {
    this.props.onClick(event);
  }
}

render() {
  const {
    buttonText,
    children,
    onClickNo,
    onClickYes,
    onClick,
  } = this.props;
  return (
    <div>
      { this.props.close ?
        <div id={this.props.id} className={this.classNames('Modal')}>
          <div className="modal-content">
            <div className="modal-text">{children}</div>
            {
              onClickNo && onClickYes &&
                <div className="modal-buttons">
                  <button onClick={this.handleNo}>No</button>
                  <div className="vertical-line-separator" />
                  <button onClick={this.handleYes}>Yes</button>
                </div>
            }
            {
              onClick &&
              <span>
                <div className="line-separator" />
                <button onClick={this.handleOnClick}>{buttonText}</button>
              </span>
            }
          </div>
        </div>
        : null
      }
    </div>
  );
}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.jsx